// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"056f00bf","239":"482da4af","732":"f4802914"}[chunkId] + ".chunk.js";
};